import { FieldSwitch } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';

import type { Button } from '../../nodeTypes/ivr';

import styles from './buttonOption.module.scss';

export interface Option extends Button {
  active: boolean;
}

interface Props {
  onChange: (option: Option) => void;
  option: Option;
}

export function ButtonOption({ onChange, option }: Props): JSX.Element {
  const handleChange = useCallback(() => {
    onChange({
      ...option,
      active: !option.active,
    });
  }, [onChange, option]);

  const fieldId = `button-${option.button}`;

  return (
    <div className={styles.root}>
      <label htmlFor={fieldId}>Press {option.button}</label>
      <FieldSwitch
        id={fieldId}
        input={{
          checked: option.active,
          name: 'active',
          value: 'active',
          onChange: handleChange,
        }}
      />
    </div>
  );
}
